const book = {
  originPathTips: "原始轨迹",
  sharpturn: "急转弯",
  emergencyBrake: "急减速",
  rapidAcceleration: "急加速",
  sharpturnCount: "急转弯次数",
  emergencyBrakeCount: "急减速次数",
  rapidAccelerationCount: "急加速次数",
  overSpeedCount: "超速次数",
  tripMaxSpeed: "最大车速(km/h)",
  tripAvgSpeed: "平均车速(km/h)",
  emergencyBrakeWidth: "150px",
  rapidAccelerationWidth: "150px",
  sharpturnWidth: "150px",
  oil: "油耗(L)",
  oilNodw: "油耗",
  oilCost: "油费(铢)",
  carbon: "排碳量(kg)",
  tip: "取消行程",
  public: "公车",
  selfDriving: "自驾",
  view: "查看行程详情",
  endAddress: "结束地址",
  adminCancelRes: "管理员取消原因",
  orderNumber: "预约单号",
  startOfJourney: "行程开始",
  endOfTrip: "行程结束",
  appointmentStatus: "预约状态",
  travelTime: "行程时长",
  startingPlace: "开始地址",
  itineraryInformation: "行程信息",
  vehicleInformation: "车辆信息",
  vehicleUseApproval: "驾驶行为",
  vehicleUseApprovalScore: "驾驶行为评分",
  historicalTrack: "历史轨迹",
  searchLabelWidth: {
    width1: "65px",
    width2: "65px",
    width3: "65px",
    width4: "65px"
  },
  searchWidth: "60px",
  vehiclePersonnel: "用车人员",
  driver: "司机",
  brand: "品牌",
  orderTime: "申请时间",
  cancelNotes: "取消原因",
  model: "车型",
  series: "系列",
  mileage: "行程里程",
  drivingBehaviorScore: "驾驶评分",
  aperationMileage: "行程里程(km)",
  aperationTiemLenthen: "行程时长(min)",
  useAdmin: "V2X用户",
  labelWidth: {
    orderNumber: "180px",
    orderTime: "180px",
    licensePlate: "200px",
    startOfJourney: "260px",
    endOfTrip: "180px",
    appointmentStatus: "180px",
    vehiclePersonnel: "100px",
    brand: "100px",
    startTime: "150px",
    endTime: "150px",
    note: "100px"
  },
  leftWidth: "80px",
  rightWidth: "80px",
  pass: "通过",
  notpass: "不通过",
  error: "请输入审核备注",
  toBeAudited: "待审核",
  toBeReported: "待出车上报",
  auditFailed: "审核不通过",
  cancelReservation: "撤销预约",
  adminCancel: "管理员撤销",
  completed: "已完成",
  toBeReportedbyReturn: "待回车上报",
  auditPass: "审核通过",
  processing: "进行中",
  cancel: "取消预约",
  error2: "请输入备注",
  success: "取消成功",
  labelWidth1: "70px",
  historyTrack: {
    playbackSpeed: "播放速度",
    playbackTrack: "轨迹回放",
    enter: "进入",
    exit: "退出",
    progress: "播放进度",
    error: {
      msg1: "请退出播放后查询数据",
      msg2: "请选择开始时间和结束时间",
      msg3: "开始时间不能大于结束时间，请重新选择",
      msg4: "只能查询7天之内的数据!",
      msg5: "无历史轨迹数据"
    },
    noData: "暂无数据"
  }
} 
export default book